import React from "react";
import { useSelector } from "react-redux";
import IconClose from "../../../Resources/svg/Icons/IconClose";
import FormTitle from "../../../Components/FormElements/FormTitle";
import RVEOGeneralInfo from "./RVEO/RVEOGeneralInfo";
import RVEOBeneficiariesSection from "./RVEO/RVEOBeneficiariesSection";
import RVEOModalitiesSection from "./RVEO/RVEOModalitiesSection";
import { useModalAside } from "./RVEO/useModalAside";
import { RVEOSimulationData } from "../../../interfaces/rveoSimulations";

interface ModalSideRVEOProps {
  modalData?: RVEOSimulationData;
  title?: string;
  subtitle?: string;
}

const ModalSideRVEO: React.FC<ModalSideRVEOProps> = ({
  modalData,
  title,
  subtitle = "",
}) => {
  const modalAsideState = useSelector(
    (state: any) => state.simulate.policy.modalAside
  );

  const { isOpen, handleClose } = useModalAside(modalAsideState);

  return (
    <div className={"modal-aside modal-aside" + (isOpen ? " is-open" : "")}>
      <div className={"modal-aside__box"}>
        <div className="modal-aside__close" onClick={handleClose}>
          <span>Cerrar</span>
          <IconClose />
        </div>
        <div className="modal-aside__body">
          <div className="modal-aside__inner">
            <div className="modal-aside__gradient"></div>
            <FormTitle title={title} />
            {subtitle !== "" && <div className="subtitle-form">{subtitle}</div>}

            {modalData && (
              <>
                <RVEOGeneralInfo modalData={modalData} />
                <RVEOBeneficiariesSection familyGroup={modalData.grupoFamiliar} />
                <RVEOModalitiesSection modalities={modalData.modalidades} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSideRVEO;
